$(document).ready(function(){

    /*

	//
	var $contMediaTop = $('.media-group.top');

	$contMediaTop.imagesLoaded( function(){

		$contMediaTop.isotope(
		{
			itemSelector: '.media',
			layoutMode: 'fitRows'
		});

	});


	//
	var $contMediaAbove = $('.media-group.above');

	$contMediaAbove.imagesLoaded( function(){

		$contMediaAbove.isotope(
		{
			itemSelector: '.media',
			layoutMode: 'fitRows'
		});

	});


	//
	var $contMediaBottom = $('.media-group.bottom');

	$contMediaBottom.imagesLoaded( function(){

		$contMediaBottom.isotope(
		{
			itemSelector: '.media',
			layoutMode: 'fitRows'
		});

	});


	//
	var $contMediaBelow = $('.media-group.below');

	$contMediaBelow.imagesLoaded( function(){

		$contMediaBelow.isotope(
		{
			itemSelector: '.media',
			layoutMode: 'fitRows'
		});

	});

    */

});
